import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import DynamicTable from '../DynamicTable';
import { TABLE_GDPR_USER, TABLE_GDPR_USER_HISTORY } from '../../Services/TableService';
import TabComponent from '../TabComponent';
import { tabsByPermission } from '.';
import { ITableFilter, setTableFilterAtom } from '../../store/recoil/TableState';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import OnlineHelp from '../OnlineHelp';
import PageHeader from '../PageHeader';

export default function GdprUserHistory() {
  const tableFilter = useRecoilValue<ITableFilter | null>(setTableFilterAtom);
  const { formatMessage: f } = useIntl();
  const tabs = React.useState(
    tabsByPermission([TABLE_GDPR_USER, TABLE_GDPR_USER_HISTORY], TABLE_GDPR_USER_HISTORY)
  )[0];
  const documentTitle = `${f({ id: 'tab.gdpr/profile/history' })} - ${f({
    id: 'menu.gdprUsersList',
  })} - ${f({
    id: 'menu.gdpr',
  })}`;
  useDocumentTitle(documentTitle);

  return (
    <>
      <PageHeader
        title={`${f({ id: 'gdprProfile.mainTitle' })} / ${f({ id: 'menu.gdprUsersList' })}`}
        onlineHelpTopic="gdpr-users"
      />
      <div className="pl-4 pr-4">
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable name={TABLE_GDPR_USER_HISTORY} mustClosed={true} filter={tableFilter} />
          </div>
        </TabComponent>
      </div>
    </>
  );
}
